import { p as prisma } from "../../../../chunks/prisma.js";
const load = async () => {
  const plans = await prisma.subscriptionPlan.findMany({
    where: { isActive: true },
    orderBy: { price: "asc" }
  });
  const serializedPlans = plans.map((plan) => ({
    ...plan,
    price: Number(plan.price)
  }));
  return {
    plans: serializedPlans
  };
};
export {
  load
};
